import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// 用来存储数据
const state = {
    userInfo:'',
}
// 操作数据
const mutations = {
    SET_USER_INFO: (state, info) => {
        state.userInfo = info
    },
}
// 响应组件中的事件
const actions = {
    // 获取用户信息
    getUserInfo(content, value){
        content.commit("SET_USER_INFO", value)
    }
}
// 用来将state数据进行加工
const getters = {

}
// 新建并暴露store
export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters
})
